import {PagingMetadataRestDto} from "@/api/pharma-cpc-product-mgmt/models";
import {
    CustomerProductWithImageOverviewRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/CustomerProductWithImageOverviewRestDtoModel";

export class PagedCustomerProductWithImageOverviewRestDtoModel {
    paging_metadata?: PagingMetadataRestDto|null;
    results: CustomerProductWithImageOverviewRestDtoModel[];

    constructor(paging_metadata: PagingMetadataRestDto | null, results: CustomerProductWithImageOverviewRestDtoModel[]) {
        this.paging_metadata = paging_metadata;
        this.results = results;
    }

    public static createWithDefaults(): PagedCustomerProductWithImageOverviewRestDtoModel {
        return new this(null, []);
    }
}
